module.exports = __webpack_public_path__ + "static/media/bg_14.bd7ea9e6.png";